import { Auth as SharedAuth } from '@gusiberi/shared'
import { deleteAllCookies } from './helpers'

/**
 * Web Auth facade: shared token storage + cookie wipe on logout.
 */
class Auth {
  static isLoggedIn() {
    return SharedAuth.isLoggedIn()
  }

  static hasToken() {
    return SharedAuth.hasToken()
  }

  static saveUserDetails(userPayload: any) {
    return SharedAuth.saveUserDetails(userPayload)
  }

  static fetchToken() {
    return SharedAuth.fetchToken()
  }

  static fetchUsername() {
    return SharedAuth.fetchUsername()
  }

  static updateUsername(username: any) {
    return SharedAuth.updateUsername(username)
  }

  static logUserOut() {
    SharedAuth.logUserOut()
    deleteAllCookies()
  }
}

export default Auth
